import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function MoneyIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M10 1v18.333M14.167 4.334h-6.25a2.917 2.917 0 0 0 0 5.833h4.166a2.917 2.917 0 1 1 0 5.834H5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
